import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { PulseCheckCategory } from '../../FinancialPlanOPL/types/goalsDTO';

interface FetcherParams {
  clientId: string;
  goalId: string;
}

export interface LargePurchaseGoalDTO {
  Accounts: string[];
  Amount: number;
  Category: PulseCheckCategory;
  Id: string;
  Inflation: number;
  IsRecurringPurchase: boolean;
  Name: string;
  OneTimeOptions: {
    IsAtRetirement: boolean;
    TargetYear: number;
  } | null;
  RecurringOptions: {
    IsAtRetirement: boolean;
    RepeatEvery: number;
    RepeatFor: number;
    StartYear: number;
  } | null;
}

export interface ExpenseGoalDTO {
  Amount: number;
  Category: PulseCheckCategory;
  Id: string;
  Name: string;
  SaveEvery: number;
  SaveForLength: number;
  SaveForPeriod: number;
  StartDate: string;
}

export interface NonFinancialGoalDTO {
  Category: PulseCheckCategory;
  Id: string;
  Name: string;
  TargetDate: string;
}

export enum SavedGoalType {
  LargePurchase,
  Expense,
  NonFinancial,
}

export interface SavedGoalDTO {
  GoalType: SavedGoalType;
  GoalData: LargePurchaseGoalDTO | ExpenseGoalDTO | NonFinancialGoalDTO;
}

export const fetchGoal = async ({ clientId, goalId }: FetcherParams): Promise<SavedGoalDTO> => {
  return authFetch(
    urlWithParams('/Consumer/PulseCheckGoals', {
      clientId,
      goalId,
    }),
  );
};

interface QueryParams {
  clientId: string;
  goalId: string;
}

export const useGoalQuery = ({ clientId, goalId }: QueryParams) => {
  return useQuery(
    queryKeys.goal(clientId, goalId),

    () => fetchGoal({ clientId, goalId }),

    {
      cacheTime: 0,
      enabled: !!goalId,
    },
  );
};
